// extracted by mini-css-extract-plugin
export default {"TouchpointQuestionary":"TouchpointQuestionary_TouchpointQuestionary__dbO+Q"};